// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivacyPolicy_container__2srta","wrapper":"PrivacyPolicy_wrapper__3Ffm4","text":"PrivacyPolicy_text__2LQlZ","logo":"PrivacyPolicy_logo__1C1lK"};